import { Box } from '@mui/material';

import TermsAndConditionStyle from './style';

import TitlePrivacyPolicyAndTermsAndCondition from '@components/molecules/titlePrivacyPolicyAndTermsAndCondition';
import NextLink from 'src/components/atoms/link';

const TermsAndCondition = () => (
  <TermsAndConditionStyle>
    <Box className="container">
      <TitlePrivacyPolicyAndTermsAndCondition isPrivacyPolicy={false} />
      <Box className="paragraph">
        <Box className="bold">หลักเกณฑ์และเงื่อนไขการใช้บริการระบบจัดอบรมหลักสูตรออนไลน์ของผู้เข้ารับการอบรม</Box>
        <Box className="indent">
          1. ผู้เข้ารับการอบรมที่ประสงค์เข้ารับการอบรมหลักสูตรแบบออนไลน์หรือทางอิเล็กทรอกนิกส์ (e-learning)
          ต้องเป็นผู้ที่มีวินัยต่อการพัฒนาตนเอง มีความตั้งใจจริง ความซื่อสัตย์ในการเข้ารับการอบรมในแต่ละหลักสูตร
          และพร้อมจะปฏิบัติตามหลักเกณฑ์และเงื่อนไขต่างๆ และให้ความร่วมมือกับกิจกรรมต่างๆ กับศูนย์ฝึกอบรมและ/หรือบริษัท
          สกิลเลน เอดูเคชั่น จำกัด (รวมเรียกว่า “ศูนย์ฝึกอบรมฯ”) อย่างเคร่งครัด (อาทิ การยืนยันตัวตนของผู้เข้ารับการอบรม
          การติดตามความต่อเนื่องในการอบรม การตรวจสอบตัวตนระหว่างอบรม การทำแบบทดสอบ การทำแบบประเมินการอบรม)
        </Box>
        <br />
        <Box className="indent">
          2. ผู้เข้ารับการอบรมจะต้องเป็นผู้มีรายชื่อและมีสิทธิเข้ารับการอบรม
          โดยผู้เข้ารับการอบรมต้องดำเนินการยืนยันตัวตน และปฏิบัติตามเงื่อนไขในขั้นตอนการติดตามความต่อเนื่องในการอบรม
          รวมถึงปฏิบัติตามคู่มือการใช้งานระบบจัดอบรมหลักสูตรออนไลน์ และระเบียบอื่นๆ ตามที่ศูนย์ฝึกอบรมฯ
          แจ้งให้ทราบอย่างเคร่งครัด
        </Box>
        <br />
        <Box className="indent">
          3.
          ผู้เข้ารับการอบรมตกลงและให้คำรับรองว่าผู้เข้ารับการอบรมเป็นผู้มีคุณสมบัติในการเข้ารับการอบรมในแต่ละหลักสูตรจริง
          และต้องเข้ารับการอบรมด้วยตนเองตลอดระยะเวลาการอบรม
          โดยรับรองว่าการอบรมหลักสูตรออนไลน์นี้ไม่สามารถให้บุคคลอื่นเข้ารับการหรือมีส่วนร่วมในการอบรมในหลักสูตรใดๆ
          ได้ไม่ว่าเหตุผลใดๆ ก็ตาม ผู้เข้ารับการอบรมรับทราบและตกลงว่า (ก) การใช้อีเมล์ (e-mail)
          สำหรับการสมัครและ/หรือการเข้ารับการอบรมกับศูนย์ฝึกอบรมฯ จะต้องเป็นอีเมล์ (e-mail) ของตนเองและเป็นเพียงอีเมล์
          (e-mail) เดียว โดยไม่สามารถนำอีเมล์ (e-mail)
          ดังกล่าวไปใช้หรือถูกนำไปใช้ร่วมกับผู้อื่นในการสมัครและ/หรือเข้ารับการอบรมได้ และ (ข) การให้ผู้อื่นใช้
          “รหัสผู้ใช้ (User ID) และรหัสผ่าน (Password)” ของตัวเอง หรือใช้ “รหัสผู้ใช้ (User ID) และรหัสผ่าน (Password)”
          ของผู้อื่น เพื่อเข้าระบบ (Login) ไม่ว่ากรณีใด จะได้รับการยกเลิกสิทธิ์เข้ารับการอบรมออนไลน์ทุกหลักสูตร
          หากพบว่ามีผู้เข้ารับการอบรมไม่มีคุณสมบัติ หรือไม่เข้ารับการอบรมด้วยตนเอง
          หรือมีบุคคลอื่นมาอบรมแทนหรือมีส่วนร่วมในการอบรม ทางศูนย์ฝึกอบรมฯ
          ขอสงวนสิทธิในการพิจารณายกเลิกความให้เห็นชอบในการเข้ารับการอบรมในหลักสูตรใดๆ และตัดสิทธิให้ไม่ผ่านการเข้าอบรม
        </Box>
        <br />
        <Box className="indent">
          4. ผู้เข้ารับการอบรมตกลงจะเข้ารับการอบรมตามวันที่และระยะเวลาการอบรมที่ศูนย์ฝึกอบรมฯ กำหนด
        </Box>
        <br />
        <Box className="indent">
          5.
          ในกรณีที่ผู้เข้ารับการอบรมเป็นผู้มีคุณสมบัติที่จะได้รับการลดจำนวนชั่วโมงการอบรมภายใต้ที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย
          (“คปภ.”) กำหนด ผู้รับเข้ารับการอบรมดังกล่าวตกลงดำเนินการและยอมรับเงื่อนไขดังนี้
        </Box>
        <Box>
          (ก) จัดส่งหลักฐานประเภทต่างๆ และภายในระยะเวลาตามที่ศูนย์ฝึกอบรมฯ กำหนด
          เพื่อยืนยันคุณสมบัติของผู้เข้ารับการอบรมว่าเป็นผู้มีสิทธิได้รับการลดจำนวนชั่วโมงการอบรม
          โดยการแนบหลักฐานผ่านช่องทางการสมัครการอบรมที่ศูนย์ฝึกอบรมฯ กำหนด ทั้งนี้ ศูนย์ฝึกอบรมฯ
          มีสิทธิในการขอให้ผู้เข้ารับการอบรมจัดส่งเอกสารหรือขอให้ชี้แจงข้อมูลเพิ่มเติมในภายหลัง
        </Box>
        <Box>(ข) รับรองว่าหลักฐานและข้อมูลใดๆ ที่แจ้งให้กับศูนย์ฝึกอบรมเป็นจริงและถูกต้อง</Box>
        <Box>
          (ค) หากปรากฎว่าผู้เข้ารับการอบรมไม่เป็นผู้มีคุณสมบัติที่จะได้รับการลดจำนวนชั่วโมงการอบรม
          และ/หรือจัดส่งหลักฐานหรือข้อมูลไม่ครบถ้วนหรือไม่ถูกต้อง และ/หรือ จัดส่งเอกสารหลังจากระยะเวลาที่ศูนย์อบรมฯกำหนด
          ผู้เข้ารับการอบรมอาจถูกพิจารณาไม่ได้รับสิทธิการลดจำนวนชั่วโมงการอบรม หรือไม่ได้เข้ารับการอบรมในหลักสูตร
          หรือถูกตัดสิทธิในการผ่านการเข้าอบรม (แล้วแต่กรณี) ตามที่ศูนย์ฝึกอบรมจะแจ้งให้ทราบ
        </Box>
        <br />
        <Box className="indent">
          6. ผู้เข้ารับการอบรมตกลงและให้คำรับรองว่าข้อมูลต่างๆ ที่ได้แจ้งศูนย์ฝึกอบรมฯ
          หรือผู้ให้บริการเป็นข้อมูลที่แท้จริง ถูกต้องและครบถ้วนเป็นปัจจุบัน และไม่มีข้อมูลและเอกสารใดๆ
          ที่ผู้เข้ารับการอบรมปกปิดอันควรที่จะแจ้งหรือเป็นความเท็จ และตกลงที่จะส่งมอบเอกสารและข้อมูลใดๆ
          เพื่อให้ทางศูนย์ฝึกอบรมฯ ตรวจสอบเมื่อได้รับการร้องขอ
        </Box>
        <Box>
          หากปรากฏว่าข้อมูลของผู้เข้ารับการอบรมเปลี่ยนแปลงไปจากที่ได้แจ้งไว้กับศูนย์ฝึกอบรมฯ
          ผู้เข้ารับการอบรมตกลงที่จะแจ้งให้ศูนย์ฝึกอบรมฯ ทราบโดยทันที
        </Box>
        <Box>
          โดยหากปรากฏว่าข้อมูลใดๆ ของผู้เข้ารับการอบรม ไม่จริงหรือเท็จ หรือปกปิดข้อมูลใดที่ควรจะต้องแจ้ง
          หรือไม่ดำเนินการแจ้งหรือแจ้งล่าช้าในกรณีที่ข้อมูลมีการเปลี่ยนแปลง ทางศูนย์ฝึกอบรมฯ
          ขอสงวนสิทธิ์ในการพิจารณายกเลิกความให้เห็นชอบในการเข้ารับการอบรมในหลักสูตร และตัดสิทธิในการผ่านการเข้าอบรม
        </Box>
        <br />
        <Box className="indent">
          7. ผู้เข้ารับการอบรมตกลงว่าจะต้องจัดเตรียมสถานที่ ระยะเวลา และอุปกรณ์ใดๆ ให้พร้อมสำหรับการอบรม
          และเตรียมตนเองให้พร้อม โดยจะต้องงดกิจกรรมใดๆ ในขณะเข้าอบรม อาทิ การงดใช้อุปกรณ์สื่อสารในขณะเข้ารับการอบรม
          (อาทิ โทรศัพท์ Tablet คอมพิวเตอร์อื่น) และงดใช้อุปกรณ์ที่ใช้อบรมในการทำกิจการอื่นๆ ในขณะการอบรม
        </Box>
        <Box>
          ผู้เข้ารับการอบรมรับทราบและตกลงว่าในระหว่างการอบรมกับทางศูนย์ฝึกอบรมฯ
          ผู้เข้ารับการอบรมจะต้องอยู่และใช้เครื่องคอมพิวเตอร์และอุปกรณ์การอบรมที่เชื่อมต่อระบบเครือข่ายอินเทอร์เน็ต
          (Internet) ในพื้นที่ราชอาณาจักรไทยเท่านั้น โดยหากปรากฏว่าผู้เข้ารับการอบรมไม่ปฏิบัติตามวิธีการดังกล่าว
          ผู้เข้ารับการอบรมอาจจะไม่มีสิทธิเข้ารับการอบรมในหลักสูตรดังกล่าว
          และไม่มีสิทธิในการขอรับเงินคืนค่าธรรมเนียมการอบรมและเรียกร้องใดๆ จากศูนย์ฝึกอบรมฯ
        </Box>
        <br />
        <Box className="indent">
          8. ผู้เข้ารับการอบรมตกลงและรับทราบว่า จะต้องถ่ายรูปบัตรประชาชนตัวจริงที่ยังไม่หมดอายุ ณ วันที่เริ่มการอบรม
          คู่กับการถ่ายใบหน้าจริงของผู้เข้าการอบรม ตามวิธีการที่ระบบได้กำหนดไว้
          โดยหากปรากฏว่าผู้เข้ารับการอบรมไม่ปฏิบัติตามวิธีการดังกล่าว ทางศูนย์ฝึกอบรมฯ
          ขอสงวนสิทธิ์ในการพิจารณายกเลิกความเห็นชอบในการเข้ารับการอบรมในหลักสูตร และตัดสิทธิ์ในการผ่านการเข้าอบรม
        </Box>
        <br />
        <Box className="indent">
          9.
          ผู้เข้ารับการอบรมตกลงและรับทราบว่าตนเองจะต้องปฏิบัติตามขั้นตอนการติดตามความต่อเนื่องในการอบรมตลอดระยะเวลาการอบรมภายใต้เงื่อนไขที่ศูนย์ฝึกอบรมฯ
          กำหนด โดยศูนย์ฝึกอบรมฯ จะมีการสุ่มการตรวจสอบการเข้าอบรม ดังเช่น
        </Box>
        <Box>
          (ก) การถ่ายรูปใบหน้าของผู้เข้ารับการอบรม
          (ซึ่งกรณีดังกล่าวไม่สามารถใช้รูปภาพหรือสิ่งอื่นใดของผู้เข้ารับการอบรมแทนได้) หรือ (ข)
          การตรวจภาพของบัตรประจำตัวประชาชนว่าตรงหรือไม่กับที่ลงทะเบียนไว้กับศูนย์ฝึกอบรมฯ ทั้งนี้
          ผู้เข้ารับการอบรมจะต้องใช้เอกสารที่ราชการออกให้เท่านั้น ได้แก่ (ก) บัตรประชาชน (ข) ใบขับขี่ (ค)
          หรือหนังสือเดินทาง (Passport) โดยเอกสารดังกล่าวจะต้องเป็นเอกสารที่ยังไม่หมดอายุและจะต้องเป็นตัวจริงเท่านั้น
        </Box>
        <Box>
          โดยหากปรากฏว่าในขณะที่ผู้เข้ารับการอบรมไม่พร้อมในการปฏิบัติขั้นตอนการติดตามความต่อเนื่องในการอบรม อาทิ
          ผู้เข้ารับการอบรมไม่ถ่ายรูปใบหน้าตนเองหรือบัตรประชาชนตามคำแนะนำของศูนย์ฝึกอบรมฯ
          และทำให้ไม่ผ่านเงื่อนไขการตรวจสอบ ทางศูนย์ฝึกอบรมฯ
          ขอสงวนสิทธิ์ในการพิจารณายกเลิกความให้เห็นชอบในการเข้ารับการอบรมในหลักสูตร และตัดสิทธิ์ในการผ่านการเข้าอบรม
        </Box>
        <Box>
          ทั้งนี้ หากพบปัญหาหรือข้อสงสัยสำหรับขั้นตอนการติดตามความต่อเนื่องในการอบรมดังกล่าว
          ผู้เข้ารับการอบรมจะต้องติดต่อและสอบถามกับศูนย์ฝึกอบรมฯ
          เพื่อรับคำแนะนำและปฏิบัติตามแนวทางดำเนินการจากศูนย์ฝึกอบรมฯ เท่านั้น
        </Box>
        <br />
        <Box className="indent">
          10.
          ผู้เข้ารับการอบรมจะต้องจัดเตรียมและใช้เครื่องคอมพิวเตอร์และอุปกรณ์การอบรมที่เชื่อมต่อระบบเครือข่ายอินเทอร์เน็ต
          (Internet) ตลอดเวลา เพื่อพร้อมสำหรับการอบรมหลักสูตรออนไลน์นี้ได้ตามมาตรฐานที่ศูนย์ฝึกอบรมฯกำหนด
        </Box>
        <br />
        <Box className="indent">
          ทั้งนี้ อุปกรณ์และเทคโนโลยีขั้นต่ำที่ผู้เข้ารับการอบรมจะต้องใช้ตลอดระยะเวลาการอบรมมีดังนี้เป็นอย่างน้อย
        </Box>
        <Box className="indent">
          (ก) แพลตฟอร์ม (Platform) ของระบบจัดอบรมหลักสูตรออนไลน์ จะรองรับการใช้งานผ่าน Web Browser Version
          ในแต่ละระบบปฏิบัติการ ดังนี้
        </Box>
        <Box className="indent bold">Chrome</Box>
        <Box className="indent">Minimum version: Version 53</Box>
        <Box className="indent">Recommended version: Version ล่าสุด</Box>
        <br />
        <Box className="indent bold">Safari</Box>
        <Box className="indent">Minimum version: Version 11</Box>
        <Box className="indent">Recommended version: Version ล่าสุด</Box>
        <br />
        <Box className="indent bold">Chrome for mobile (android)</Box>
        <Box className="indent">Minimum version: Version 81</Box>
        <Box className="indent">Recommended version: Version ล่าสุด</Box>
        <br />
        <Box className="indent bold">Safari for mobile (iOS)</Box>
        <Box className="indent">Minimum version: Version 11</Box>
        <Box className="indent">Recommended version: Version ล่าสุด</Box>
        <br />
        <Box className="indent">(ข) อุปกรณ์คอมพิวเตอร์ที่ใช้งาน</Box>
        <Box className="indent bold">CPU</Box>
        <Box className="indent">Minimum: Intel Premium 4 processor</Box>
        <Box className="indent">Recommended: Intel core i3 ขึ้นไป</Box>
        <br />
        <Box className="indent bold">Memory</Box>
        <Box className="indent">Minimum: 2 GB</Box>
        <Box className="indent">Recommended: 4GB ขึ้นไป</Box>
        <br />
        <Box className="indent">(ค) ความเร็วของอินเตอร์เน็ต (Internet) ขั้นต่ำที่แนะนำ</Box>
        <Box className="indent bold">ระดับความชัด 480p</Box>
        <Box className="indent">Minimum download speed: 2Mbps Latency &#60; 800 ms</Box>
        <Box className="indent">Recommended speed: 4Mbps Latency &#60; 500 ms</Box>
        <br />
        <Box className="indent bold">ระดับความชัด 720p</Box>
        <Box className="indent">Minimum download speed: 4Mbps Latency &#60; 800 ms</Box>
        <Box className="indent">Recommended speed: 6Mbps Latency &#60; 500 ms</Box>
        <br />
        <Box className="indent bold">ระดับความชัด 1080p</Box>
        <Box className="indent">Minimum download speed: 6Mbps Latency &#60; 800 ms</Box>
        <Box className="indent">Recommended speed: 8Mbps Latency &#60; 500 ms</Box>
        <br />
        <Box className="indent">(ง) ต้องเป็นอุปกรณ์คอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ที่มีกล้องติดตั้ง</Box>
        <br />
        <Box className="indent">
          11. ผู้เข้ารับการอบรมตกลงว่าศูนย์ฝึกอบรมฯ ไม่มีหน้าที่ในการดำเนินการแก้ไขข้อมูลของผู้เข้ารับการอบรม
          รวมถึงแก้ไขข้อบกพร่องหรือปัญหาการใช้บริการในอุปกรณ์การอบรมของผู้เข้ารับการอบรมที่มีสาเหตุเกิดจากความผิดและ/หรือข้อบกพร่องของระบบหรืออุปกรณ์ของผู้เข้ารับการอบรมเอง
          ซึ่งอาจมีคุณสมบัติหรือคุณภาพต่ำกว่ามาตรฐานการใช้งานระบบจัดอบรมหลักสูตรออนไลน์
          ความขัดข้องในระหว่างการอบรมอันเกิดจากผู้เข้ารับการอบรมไม่ว่ากรณีใด
          ไม่สามารถใช้เป็นเหตุขอทำแบบทดสอบได้มากกว่าที่กำหนด หรือเรียกร้องให้ศูนย์ฝึกอบรมฯ ดำเนินการใดๆ
        </Box>
        <br />
        <Box className="indent">
          12. ผู้เข้ารับการอบรมทราบว่าการอบรมหลักสูตรออนไลน์นี้เป็นการบันทึกวีดีโอหรือไฟล์การอบรมไว้ล่วงหน้า
        </Box>
        <br />
        <Box className="indent">
          13. ผู้เข้ารับการอบรมรับทราบว่าตนเองสามารถส่งคำถาม ข้อสงสัย หรือบทสนทนากับวิทยากรหรือศูนย์ฝึกอบรมฯ
          ในขณะอบรมได้ (Discussion Board) ทั้งนี้ ผู้เข้ารับการอบรมตกลงว่าจะต้องใช้คำและวาจาที่สุภาพ โดยไม่เป็นคำหยาบ
          คำหมิ่นประมาท หรือละเมิดสิทธิทางกฎหมายกับบุคคลอื่น และจะสอบถามหรือสนทนาที่เกี่ยวข้องกับหลักสูตรที่อบรมเท่านั้น
          ในกรณีที่ผู้เข้ารับการอบรมไม่ปฏิบัติตามวรรคต้น ศูนย์ฝึกอบรมฯ มีสิทธิที่จะพิจารณาลบข้อความดังกล่าว
          (ไม่ว่าทั้งหมดหรือบางส่วน) ได้ โดยไม่ต้องแจ้งให้ผู้เข้ารับการอบรมทราบ
        </Box>
        <br />
        <Box className="indent">
          14. การทำแบบทดสอบทุกประเภท ไม่มีการเฉลย ผู้เข้ารับการอบรมสามารถค้นหาทุกคำตอบด้วยตนเอง
          โดยการศึกษาทบทวนเนื้อหาบทเรียนได้ตลอดช่วงระยะเวลาการอบรมหลักสูตรออนไลน์นี้ตามระยะเวลาที่ศูนย์ฝึกอบรมฯ กำหนด
          และเกณฑ์การผ่านการทดสอบจะเป็นไปตามที่ศูนย์ฝึกอบรมฯ กำหนด
        </Box>
        <br />
        <Box className="indent">
          15. ศูนย์ฝึกอบรมฯ ขอสงวนสิทธิ์ในการเพิกถอนผู้เข้ารับการอบรมที่มีพฤติกรรมไม่สุจริตหรือไม่ปฏิบัติตามเงื่อนไขใดๆ
          ออกจากระบบจัดอบรมหลักสูตรออนไลน์ของศูนย์ฝึกอบรมฯ ทันทีที่พบ โดยไม่จำเป็นต้องแจ้งให้ทราบ
        </Box>
        <br />
        <Box className="indent">
          16. ศูนย์ฝึกอบรมฯ สงวนสิทธิ์ในกระบวนการจัดอบรมหลักสูตรออนไลน์ทุกขั้นตอน อาทิ
          การพิจารณาอนุมัติสิทธิให้เข้ารับการอบรม การระงับ หรือยกเลิกการให้สิทธิ์เข้ารับการอบรม การพิจารณาผลการทดสอบ
          การพิจารณารับรองการผ่านแต่ละหลักสูตร การพิจารณาอนุมัติให้หนังสือรับรอง (ทั้งแบบออนไลน์หรือต้นฉบับ)
          ตามหลักเกณฑ์และเงื่อนไขที่ได้กำหนดไว้ เป็นต้น โดยศูนย์ฝึกอบรมฯ ไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
          หรือชี้แจงรายละเอียดเป็นรายบุคคล นอกจากนี้ ศูนย์ฝึกอบรมฯ
          อาจนำส่งข้อมูลและแจ้งเหตุการณ์ดังกล่าวให้หน่วยงานอื่นทราบ อาทิ คปภ. หรือศูนย์ส่งเสริมการพัฒนาความรู้ตลาดทุน
          ตลาดหลักทรัพย์แห่งประเทศไทย (แล้วแต่กรณี)
        </Box>
        <br />
        <Box className="indent">17. เงื่อนไขและวิธีการคืนค่าธรรมเนียมการอบรม</Box>
        <Box className="indent">(ก) สาเหตุและเงื่อนไขการคืนค่าธรรมเนียมการอบรม</Box>
        <Box className="indent">
          (1) การขอคืนค่าธรรมเนียมการอบรมในช่วงระยะเวลาก่อนถึงกำหนดเริ่มการอบรม ในช่วงระยะเวลาก่อนถึงกำหนดเริ่มการอบรม
          หากผู้เข้ารับการอบรมเป็นผู้มีสิทธิเข้ารับการอบรมและประสงค์จะขอคืนค่าธรรมเนียมการอบรม
          ผู้เข้ารับการอบรมจะต้องทำคำร้องขอโดยแจ้งให้ศูนย์ฝึกอบรมฯ ทราบเป็นลายลักษณ์อักษรล่วงหน้าอย่างน้อย 4 วัน
          ก่อนถึงกำหนดเริ่มการอบรมนั้นๆ
        </Box>
        <Box className="indent">
          (2) การขอคืนค่าธรรมเนียมการอบรมในช่วงระหว่างการอบรม
          ผู้เข้ารับการอบรมอาจจะมีสิทธิในการขอคืนค่าธรรมเนียมการอบรมได้
          หากปรากฏว่าผู้เข้ารับการอบรมอยู่ภายใต้เงื่อนไขทั้งหมดดังต่อไปนี้
          ผู้เข้ารับการอบรมไม่สามารถเข้ารับการอบรมได้หรือ เข้ารับการอบรมได้แต่ระบบการจัดอบรมไม่มีประสิทธิภาพ
          ซึ่งมีสาเหตุอันเนื่องจากความบกพร่องหรือผิดปกติในระบบจัดอบรมหลักสูตรออนไลน์ของศูนยฝึกอบรมฯ เองเท่านั้น
          โดยต้องไม่ใช่สาเหตุที่เกิดจากความผิดและ/หรือข้อบกพร่องของผู้เข้ารับการอบรมหรือบุคคลอื่นเอง อาทิ
          ระบบเทคโนโลยีหรืออุปกรณ์ของผู้เข้ารับการอบรม ผู้เข้ารับการอบรมจะต้องไม่ได้เริ่มเข้ารับการอบรมแล้ว
          เป็นสัดส่วนเกินกว่าร้อยละ 25 ของระยะเวลาหรือชั่วโมงการอบรมทั้งหมดในหลักสูตรนั้นๆ และ
          ผู้เข้ารับการอบรมได้ทำคำร้องขอการคืนค่าธรรมเนียมการอบรม พร้อมข้อมูลและหลักฐานที่แสดงถึงเหตุดังกล่าวที่ครบถ้วน
          โดยแจ้งให้ศูนย์ฝึกอบรมฯ ทราบเป็นลายลักษณ์อักษรภายในระยะเวลาไม่เกิน 3 วัน นับตั้งแต่วันที่กำหนดการอบรมนั้นๆ
          ได้เริ่มขึ้น
        </Box>
        <br />
        <Box className="indent">(ข) การพิจารณาคำร้องขอคืนค่าธรรมเนียมการอบรม</Box>
        <Box className="indent">
          (1) ศูนย์ฝึกอบรมฯ ตกลงจะพิจารณาคำร้องขอคืนค่าธรรมเนียมการอบรม
          และตอบกลับผลพิจารณาว่าจะคืนค่าธรรมเนียมการอบรมหรือไม่โดยเร็ว ภายในระยะเวลาไม่เกิน 2 วันทำการ
          นับตั้งแต่ระยะเวลาที่ศูนย์ฝึกอบรมฯ ได้รับคำร้องขอตามวิธีการ
          พร้อมกับข้อมูลและหลักฐานที่ถูกต้องและครบถ้วนสำหรับการพิจารณาคำร้องขอดังกล่าวจากผู้เข้ารับการอบรม
        </Box>
        <Box className="indent">
          (2) ผู้เข้ารับการอบรมตกลงและรับทราบว่าในช่วงระยะเวลาการพิจารณาคำร้องขอของศูนย์ฝึกอบรมฯ ดังกล่าว
          ระยะเวลาการอบรมยังดำเนินต่อเนื่อง
          โดยไม่ถือเป็นเหตุที่จะระงับหรือหยุดระยะเวลาการอบรมของผู้เข้ารับการอบรมที่อยู่ระหว่างการรอพิจารณาการคืนค่าธรรมเนียมการอบรมได้
          ดังนั้น หากปรากฏว่า
          ผลการพิจารณาคำร้องขอคืนค่าธรรมเนียมการอบรมออกเมื่อระยะเวลาการอบรมนั้นเสร็จสิ้นแล้วหรือทำให้ผู้เข้ารับการอบรมมีระยะเวลาอบรมน้อยลง
          ผู้เข้ารับการอบรมไม่มีสิทธิในการเรียกร้องใดๆ กับศูนย์ฝึกอบรมทั้งสิ้น
        </Box>
        <br />
        <Box className="indent">
          (ค) การคืนค่าธรรมเนียมการอบรม กรณีที่ศูนย์ฝึกอบรมฯ
          พิจารณาแล้วเห็นว่าผู้เข้ารับการอบรมเป็นผู้มีสิทธิได้รับการคืนค่าธรรมเนียมการอบรม ศูนย์ฝึกอบรมฯ
          จะแจ้งให้ผู้เข้ารับการอบรมดังกล่าวทราบ และจะดำเนินการคืนค่าธรรมเนียมภายใน 15
          วันทำการนับตั้งแต่วันที่ได้แจ้งให้ผู้เข้ารับการอบรมทราบ
          โดยวิธีการคืนค่าธรรมเนียมการอบรมเช่นเดียวหรือช่องทางเดียวกับที่ผู้เข้ารับการอบรมชำระค่าธรรมเนียมการอบรมให้ศูนย์ฝึกอบรมฯ
          ในขณะที่ลงทะเบียนการอบรม
        </Box>
        <br />
        <Box className="indent">
          (ง) ข้อสงวนสิทธิ์ ศูนย์ฝึกอบรมฯ ขอสงวนสิทธิ์ในการพิจารณาไม่คืนค่าธรรมเนียมการอบรมในทุกกรณีๆ
          หากปรากฎว่าผู้เข้ารับการอบรมไม่ได้ปฏิบัติตามเงื่อนไขและ/หรือไม่เป็นบุคคลที่มีสิทธิในการได้รับคืนค่าธรรมเนียมการอบรมตามระเบียบที่ศูนย์ฝึกอบรมฯ
          กำหนด รวมถึงอาจพิจารณาตัดสิทธิการเข้ารับการอบรมในหลักสูตรใดๆ
          หากผู้เข้ารับการอบรมมีเจตนาทุจริตหรือปลอมแปลงข้อมูลและหลักฐานในการขอคืนค่าธรรมเนียมการอบรม ไม่ว่ากรณีใดๆ ก็ตาม
          ผู้เข้ารับการอบรมตกลงและยอมรับว่าผลการพิจารณาการคืนค่าธรรมเนียมการอบรมของศูนย์ฝึกอบรมเป็นที่เด็ดขาด
        </Box>
        <br />
        <Box className="indent">
          18. ผู้เข้ารับการอบรมตกลงและรับทราบว่าบริษัท สกิลเลน เอดูเคชั่น จำกัด อาจมีการเก็บ รวบรวม
          เปิดเผยต่อหน่วยงานที่เกี่ยวข้อง หรือประมวลผลข้อมูลต่างๆ ของผู้เข้ารับการอบรม โดยมีวัตถุประสงค์ดังเช่น
          เพื่อเป็นฐานข้อมูลลูกค้า การนำเสนอหรือเป็นข้อมูลเกี่ยวกับการให้บริการต่างๆ
          หรือเป็นช่องทางการติดต่อกับผู้เข้ารับการอบรมเกี่ยวกับการปรับปรุง แก้ไข เปลี่ยนแปลงระบบของบริษัท
        </Box>
        <br />
        <Box className="indent">
          19. หากมีข้อสงสัยหรือคำแนะนำ และการแจ้งหรือดำเนินการขอคืนค่าธรรมเนียมการอบรม โปรดติดต่อศูนย์ฝึกอบรมฯ ที่
          &nbsp;
          <NextLink color="#3155FF" underline="always" href="mailto:cpd.info@skilllane.com">
            cpd.info@skillLane.com
          </NextLink>{' '}
          เท่านั้น
        </Box>
      </Box>
    </Box>
  </TermsAndConditionStyle>
);

export default TermsAndCondition;
